import React, { useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Button, Text } from '@chakra-ui/react';
import { FiMail, FiLock } from 'react-icons/fi';
import * as Yup from 'yup';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import getValidationErrors from '../../utils/getValidationErrors';
import Input from '../../components/Inputs/Input';
import logoImg from '../../assets/logo/pintor10.png';

import { AnimationContainer, Container, Content, FormView } from './styles';

interface SignInFormData {
	email: string;
	password: string;
}

const DeleteAccountLogin: React.FC = () => {
	const formRef = useRef<FormHandles>(null);

	const { signInPintor10 } = useAuth();
	const { addToast } = useToast();

	const [isLoading, setIsLoading] = useState(false);

	async function handleSubmit(form: SignInFormData) {
		try {
			setIsLoading(true);
			formRef.current?.setErrors({});

			const schema = Yup.object().shape({
				email: Yup.string()
					.required('E-mail obrigatório')
					.email('Digite um e-mail válido'),
				password: Yup.string().min(6, 'No minimo 6 dígitos'),
			});

			await schema.validate(form, {
				abortEarly: false,
			});

			const { email, password } = form;
			
			await signInPintor10({
				email: email,
				password: password,
			});

			setIsLoading(false);
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRef.current?.setErrors(errors);
				setIsLoading(false);
				return;
			}

			addToast({
				type: 'error',
				title: 'Erro na autenticação',
				description: 'Ocorreu um erro ao fazer login, cheque as credenciais.',
			});

			setIsLoading(false);
		}
	}

	return (
		<Container>
			<Content>
				<AnimationContainer>
					<img src={logoImg} alt="RazioDigital" />

					<FormView ref={formRef} onSubmit={handleSubmit}>
						<Text py={0} fontSize="2xl" fontWeight={600} color="red.800">Faça o login</Text>
						<Text py={0} fontSize="2xl" fontWeight={600} color="red.800">para deletar a sua conta</Text>
						<Text pt={0} fontSize="2xl" fontWeight={600} color="red.800">em Pintor10</Text>

						<Input
							name="email"
							type="email"
							placeholder="E-mail"
							icon={FiMail}
						/>

						<Input
							name="password"
							type="password"
							placeholder="Senha"
							icon={FiLock}
						/>

						<Button
							type="submit"
							isLoading={isLoading}
							fontSize={20}
							fontWeight={600}
							mt={2}
							py={7}
							bg="blue.500"
							color="white"
							w="100%"
							_hover={{
								bg: "blue.600"
							}}
							_focus={{
								bg: "blue.600"
							}}
						>
							Entrar
						</Button>
					</FormView>
				</AnimationContainer>
			</Content>
		</Container>
	)
}

export default DeleteAccountLogin;